import { gql } from '@apollo/client';

export const CHAT = gql`
  mutation chat($messages: [ChatMessage!]!) {
    chat(messages: $messages)
  }
`;
